import stores from 'cd-eft/models/Stores';
import { action } from 'mobx';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as eftPrjAdminApi from 'cd-eft/services/eftPrjAdminApi';
import { EftGetProjectReponseDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';

const libraryStore = stores.AppStore.projectsLibraryStore;

export class ProjectContainerVM {
  history: any;
  constructor(history) {
    this.history = history;
    libraryStore.projectContainerInitializing = true;
  }

  //  load all statuses ->
  @action.bound async getProjectStatuses() {
    try {
      const response: any = await eftPrjAdminApi.ValueDomainController.getAllProjectStatusTypesUsingGET();
      if (response.data) {
        libraryStore.projectStatuses = [...response.data];
        libraryStore.filterProjectStatuses.add(1);
        libraryStore.filterProjectStatuses.add(2);
        libraryStore.filterProjectStatuses.add(3);
      }
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
  }
  //  <- load all statuses

  @action.bound async initProjectContainer () {
    // isLoading variable changes should effectively be duplicated within getProjects.
    // Doing this as getProjects is called elsewhere alone, but getProjectStatuses is also part of container loading.
    libraryStore.projectContainerInitializing = true;
    libraryStore.incrementLoading();
    await this.getProjectStatuses();
    await getProjects();
    libraryStore.decrementLoading();
    libraryStore.projectContainerInitializing = false;
  }
}

//  load all projects ->
export const getProjects = async () => {
  libraryStore.incrementLoading();
  const localStorageUsername: any = localStorage.getItem('username');
  if (localStorageUsername) {
    try {
      const response: any = await eftPrjAdminApi.EftProjectController.getAllProjectsByOwnerNameUsingGET(
        localStorageUsername
      );
      if (response.data) {
        const modifiedProjectList = await excludeProjectsWithoutSession(response.data);
        libraryStore.projects = [...modifiedProjectList];
        libraryStore.filteredProjects = [...modifiedProjectList];
      }
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      libraryStore.decrementLoading();
    }
  }
};
//  <- load all projects

const excludeProjectsWithoutSession = async (projectList) => {
  const modifiedProjectList: any[] = [];
  let hasAnInvalidState = false;
  let missingCount = 0;
  projectList.forEach((project) => {
    if (project.sessionList && project.sessionList.length > 0) {
      modifiedProjectList.push(project);
    }
    else {
      hasAnInvalidState = true;
      missingCount++;
    }
  })
  if (hasAnInvalidState) {
    await MessageCenter.addNotificationFromCode('Project_08');
  }
  return modifiedProjectList;
}

export enum projectClassId {
  design = 1,
  hydrology = 4,
}
